import React, { createContext, useContext, ReactNode } from 'react'
import useStorage from 'hooks/useStorage'
// import { PATCH } from 'api/request'
// import { user } from 'api/urls'

export type Languages = 'pl' | 'en'
const STORAGE_KEY = 'language'

const LanguageContext = createContext<[Languages, React.Dispatch<React.SetStateAction<Languages>>] | undefined>(undefined)

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setState] = useStorage<Languages>('pl', STORAGE_KEY, false)

  const sendLanguage = async (language: Languages) => {
    // try {
    //   await PATCH(user, { body: { language } })
    // } catch (error) {

    // }
  }

  const updateLanguage: React.Dispatch<React.SetStateAction<Languages>> = getState => {
    setState(prev => {
      const newState = typeof getState === 'function' ? getState(prev) : getState
      sendLanguage(newState)
      return newState
    })
  }

  return (
    <LanguageContext.Provider value={[state, updateLanguage]}>
      {children}
    </LanguageContext.Provider>
  )
}